import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useReportStore } from '../store';

export function useReportUrlSync() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { dateRange, setDateRange, selectedCategoryIds, setCategoryIds } =
    useReportStore();

  useEffect(() => {
    const urlStart = searchParams.get('start');
    const urlEnd = searchParams.get('end');
    const urlCategories = searchParams.get('categories');

    if (urlStart && urlEnd) {
      setDateRange({ start: urlStart, end: urlEnd });
    }

    if (urlCategories) {
      const categoryIds = urlCategories.split(',').filter(Boolean);
      if (categoryIds.length > 0) {
        setCategoryIds(categoryIds);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();

    if (dateRange.start) params.set('start', dateRange.start);
    if (dateRange.end) params.set('end', dateRange.end);
    if (selectedCategoryIds.length > 0) {
      params.set('categories', selectedCategoryIds.join(','));
    }

    setSearchParams(params, { replace: true });
  }, [dateRange, selectedCategoryIds, setSearchParams]);
}
